"use client";

import React, { createContext, useContext, useState, useEffect } from "react";
import Lenis from "@studio-freight/lenis";

// Create a Context
const LenisContext = createContext<{
    lenis: Lenis | null;
    lenisStop: () => void;
    lenisStart: () => void;
}>({ lenis: null, lenisStop: () => {}, lenisStart: () => {} });

// Create a provider component
export const LenisProvider = ({ children }: { children: React.ReactNode }) => {
    const [lenis, setLenis] = useState<Lenis | null>(null);
    const [isScrollEnabled, setIsScrollEnabled] = useState(false);

    useEffect(() => {
        // Initialize lenis instance only on the client side
        if (typeof window !== "undefined") {
            const lenisInstance = new Lenis({
                duration: 1.2,
                easing: (t) => Math.min(1, 1.001 - Math.pow(2.25, -10 * t)),
            });

            const raf = function (time: any) {
                lenisInstance.raf(time);
                requestAnimationFrame(raf);
            };

            // CareerPage Apply Button
            document
                .querySelectorAll(".careerFormButton")
                .forEach(function (btn: any) {
                    btn.addEventListener("click", () => {
                        console.log("header hihi");
                        lenisInstance.scrollTo("#kd-form");
                    });
                });
            requestAnimationFrame(raf);

            setLenis(lenisInstance);
            // Disable scrolling for the first second
            lenisInstance.stop();
            setTimeout(() => {
                lenisInstance.start();
                setIsScrollEnabled(true);
            }, 1000);

            return () => {
                // Clean up lenis instance if necessary
                lenisInstance.destroy();
            };
        }
    }, []);

    // useEffect(() => {
    //     if (lenis) {
    //         console.log("Lenis instance initialized:", lenis);
    //     }
    // }, [lenis]);

    const lenisStop = () => {
        lenis?.stop();
    };

    const lenisStart = () => {
        lenis?.start();
    };

    return (
        <LenisContext.Provider value={{ lenis, lenisStop, lenisStart }}>
            {children}
        </LenisContext.Provider>
    );
};

export const useLenisContext = () => {
    const context = useContext(LenisContext);
    if (!context) {
        throw new Error("useLenisContext must be used within a LenisProvider");
    }
    return context;
};
